<template>
  <div>
    <el-form ref="formRef"  label-width="88px">
      <el-form-item label="用户留言：">
        <p>{{loveMsg}}</p>
      </el-form-item>
      <el-form-item label="一伴回复：">
        <el-input :rows="8" type="textarea" v-model="preMsg" placeholder="300字以内" :maxlength="300" style="width:33em;" show-word-limit/>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { replyLoveMsg } from "@/api/url";

export default {
  name: "MsgReplyDialog",
  props: {
    value: Object
  },
  data() {
    return {
      loveMsg: this.value.row.loveMsg,
      msgId: this.value.row.msgId,
      id: this.value.row.replyLoveMsg?this.value.row.replyLoveMsg.id: 0,
      preMsg: this.value.row.replyLoveMsg?this.value.row.replyLoveMsg.msg:"",
      loading: false,
      // msg:'',
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.preMsg) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '回复不能为空',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = {};
      param['id'] = this.id;
      param['msgId'] = this.msgId;
      param['msg'] = this.preMsg;
      postFormData(replyLoveMsg, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
